import { get } from 'lodash-es';
import { INVENTORY_TYPES_CAPITALIZED } from 'client/constants/inventory-types';
import {
  TITLE_ISSUE,
  USAGE_TYPE,
  VEHICLE_HISTORY_POINTS_EXPERIAN,
} from 'client/site-modules/shared/components/inventory/helpers/vehicle-history-helper';

function getAccidentCopy(accidentText) {
  if (!accidentText) return '';

  switch (accidentText) {
    case '0':
      return 'No accidents';
    case '1':
      return '1 Accident';
    default:
      return `${accidentText} Accidents`;
  }
}

export function getIconClasses({ accidentText, cleanTitle, isGrayIcons }) {
  const checkmarkClass = isGrayIcons ? 'icon-checkmark text-gray-darker' : 'icon-checkmark text-primary-darker';
  return accidentText > 0 || cleanTitle === false ? 'icon-warning2' : checkmarkClass;
}

export function getTitleDisplayDescription(historyInfo) {
  const titleDescription = get(historyInfo, 'titleDescription');
  const accidentText = get(historyInfo, 'accidentText');
  const cleanTitle = get(historyInfo, 'cleanTitle');

  if (cleanTitle === false) {
    return titleDescription || TITLE_ISSUE;
  }
  return getAccidentCopy(accidentText);
}

export function getOwnerDisplayDescription(historyInfo) {
  const ownersNumber = get(historyInfo, 'ownerText');
  if (!ownersNumber) return '';
  if (ownersNumber === '1') return '1 Owner';
  return `${ownersNumber} Owners`;
}

export function getUsageTypeDisplayDescription(historyInfo) {
  const usageType = get(historyInfo, 'usageType');
  const type = usageType === 'Lease' ? 'Lease_SRP_expanded' : usageType;
  const text = type && get(VEHICLE_HISTORY_POINTS_EXPERIAN[USAGE_TYPE][type], 'content');
  return text || '';
}

export function getRecurrentRangeValue(vehicle) {
  const expectedRangeMin = vehicle?.thirdPartyInfo?.recurrentInsights?.expectedRange?.min;
  const expectedRangeMax = vehicle?.thirdPartyInfo?.recurrentInsights?.expectedRange?.max;

  if (!expectedRangeMin && !expectedRangeMax) {
    return '';
  }

  return expectedRangeMin === expectedRangeMax
    ? `${expectedRangeMin} mi est. range`
    : `${expectedRangeMin} - ${expectedRangeMax} mi est. range`;
}

export function getRecurrentScoreValue(vehicle) {
  const rangeScoreDescriptor = vehicle?.thirdPartyInfo?.recurrentInsights?.rangeScoreDescriptor;

  return rangeScoreDescriptor ? `${rangeScoreDescriptor} battery score` : '';
}

export function getPhotoAltText(vehicle) {
  const condition = INVENTORY_TYPES_CAPITALIZED[vehicle?.type] || 'Certified Pre-Owned';
  const { styleInfo = {}, vehicleColors } = vehicle?.vehicleInfo || {};
  const exteriorColor = vehicleColors?.exterior || {};
  const numberOfSeats = styleInfo.numberOfSeats;
  const style =
    typeof styleInfo.style === 'string'
      ? styleInfo.style.replace(/\s*\([^)]+\)|\s*w\/Prod\. End(?:\s+[\d/]+)?/gi, '').trim()
      : '';

  return [
    condition,
    exteriorColor.genericName,
    styleInfo.year,
    styleInfo.make,
    styleInfo.model,
    numberOfSeats !== null && numberOfSeats !== undefined ? `${numberOfSeats} seat` : null,
    style,
    exteriorColor.name ? `(${exteriorColor.name})` : null,
  ]
    .filter(value => !!value?.toString().trim())
    .join(' ');
}
